import * as yup from 'yup'

/**
 * Mirrors `GigsafeUserInviteCreateDto`. The markets rule is the interesting one: the backend
 * cross-validates the pair with `@ValidateIf(payload => !payload.allMarkets)` on `marketIds` and
 * `@ValidateIf(payload => !payload.marketIds?.length)` on `allMarkets`, so allMarkets off with an
 * empty selection trips BOTH validators and 400s.
 */
export const inviteGigsafeUserFormValidator = yup.object({
  email: yup.string().trim().required('Email is required').email('Enter a valid email'),
  firstName: yup.string().trim().required('First name is required'),
  lastName: yup.string().trim().required('Last name is required'),
  roleId: yup.string().trim().required('Role is required'),
  allMarkets: yup.boolean().required(),
  marketIds: yup.array(yup.string().required()).when('allMarkets', {
    is: false,
    then: (schema) => {
      return schema.min(1, 'Select at least one market')
    },
    otherwise: (schema) => {
      return schema
    },
  }),
})
